/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChapterReadStatus } from '../models/ChapterReadStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChapterReadStatusesService {
    /**
     * Get all chapter read statuses
     * @returns ChapterReadStatus successful
     * @throws ApiError
     */
    public static getAllChapterReadStatuses(): CancelablePromise<Array<ChapterReadStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/chapter_read_statuses.json',
        });
    }
    /**
     * Update chapter read status
     * @param chapterId Chapter ID
     * @param requestBody
     * @returns ChapterReadStatus successful
     * @throws ApiError
     */
    public static updateChapterReadStatus(
        chapterId: string,
        requestBody?: {
            read: boolean;
        },
    ): CancelablePromise<ChapterReadStatus> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/chapter_read_statuses/{chapterId}.json',
            path: {
                'chapterId': chapterId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
